<!-- Admin user profile area -->
<div class="chat-user-sidebar">
  <header class="chat-profile-header">
    <button class="btn close-icon p-0" (click)="toggleSidebar('chat-user-sidebar')">
      <i data-feather="x"></i>
    </button>
    <!-- User Information -->
    <div class="header-profile-sidebar">
      <div class="avatar box-shadow-1 avatar-xl avatar-border">
        <img [src]="userProfile?.avatar" alt="user_avatar" />
        <span
          class="avatar-status-xl"
          [ngClass]="{
            'avatar-status-offline': userProfile?.status == 'offline',
            'avatar-status-online': userProfile?.status == 'online',
            'avatar-status-busy': userProfile?.status == 'busy',
            'avatar-status-away': userProfile?.status == 'away'
          }"
        ></span>
      </div>
      <h4 class="chat-user-name">{{ userProfile?.firstname }} {{ userProfile?.lastname }}</h4>
      <span class="user-post">{{ userProfile?.role }}</span>
    </div>
    <!--/ User Information -->
  </header>
  <!-- User Details start -->
  <div class="profile-sidebar-area">
    <h6 class="section-label mb-1 mt-3">{{ "STATE" | translate }}</h6>
    <ul class="list-unstyled user-status">
      <li class="pb-1">
        <div class="custom-control custom-control-success custom-radio">
          <input type="radio" id="activeStatusRadio" name="userStatus" class="custom-control-input" [(ngModel)]="userProfile.status" (change)="updateUserStatus()" value="online" checked />
          <label class="custom-control-label ml-25" for="activeStatusRadio">{{ "ACTIVE" | translate }}</label>
        </div>
      </li>
      <li class="pb-1">
        <div class="custom-control custom-control-danger custom-radio">
          <input type="radio" id="dndStatusRadio" [(ngModel)]="userProfile.status" name="userStatus" class="custom-control-input" (change)="updateUserStatus()" value="busy" />
          <label class="custom-control-label ml-25" for="dndStatusRadio">{{ "DO_NOT_DISTURB" | translate }}</label>
        </div>
      </li>
      <li class="pb-1">
        <div class="custom-control custom-control-warning custom-radio">
          <input type="radio" id="awayStatusRadio" [(ngModel)]="userProfile.status" name="userStatus" class="custom-control-input" (change)="updateUserStatus()" value="away" />
          <label class="custom-control-label ml-25" for="awayStatusRadio">{{ "AWAY" | translate }}</label>
        </div>
      </li>
      <li class="pb-1">
        <div class="custom-control custom-control-secondary custom-radio">
          <input type="radio" id="offlineStatusRadio" [(ngModel)]="userProfile.status" name="userStatus" class="custom-control-input" (change)="updateUserStatus()" value="offline" />
          <label class="custom-control-label ml-25" for="offlineStatusRadio">{{ "OFFLINE" | translate }}</label>
        </div>
      </li>
    </ul>
  </div>
  <!-- User Details end -->
</div>
<!--/ Admin user profile area -->
